import React from "react";

export const Image = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32px"
      height="32px"
      viewBox="0 0 24 24"
      class="styles-premiumIcon-3nxP1vno"
    >
      <defs>
        <linearGradient
          id="9uyyd0dnra"
          x1="39.966%"
          x2="67.41%"
          y1="71.229%"
          y2="0%"
        >
          <stop offset="0%" stop-color="#2175D9"></stop>
          <stop offset="100%" stop-color="#2789FF"></stop>
        </linearGradient>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-749 -116) translate(749 116)">
            <rect width="24" height="24" fill="#2789FF" rx="2"></rect>
            <path
              fill="#FFF"
              fill-rule="nonzero"
              d="M16.44 16.75H6.631l-1.71-4.61c.736.494 1.617.772 2.55.772 1.857 0 3.334-1.754 4.063-3.51.73 1.756 2.207 3.51 4.063 3.51.928 0 1.812-.282 2.552-.782l-1.71 4.62zM16.687 18.556H6.367c-.242 0-.437-.197-.437-.455 0-.24.195-.437.437-.437h10.32c.241 0 .437.196.437.455 0 .24-.196.437-.437.437zM11.536 8.645c.73 0 1.323-.592 1.323-1.322 0-.73-.592-1.323-1.323-1.323-.73 0-1.322.592-1.322 1.323 0 .73.592 1.322 1.322 1.322zM4.45 11.669c.47 0 .85-.38.85-.85s-.38-.85-.85-.85-.85.38-.85.85.38.85.85.85zM18.622 9.968c.47 0 .85.38.85.85s-.38.85-.85.85-.85-.38-.85-.85.38-.85.85-.85z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};